const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
let TZ = BROWSER_TZ;

export const setOrgTimeZone = (tz) => {
  if (!tz) { TZ = BROWSER_TZ; return; }
  try { new Intl.DateTimeFormat("en-US", { timeZone: tz }); TZ = tz; } catch (e) { TZ = BROWSER_TZ; }
};
export const getOrgTimeZone = () => TZ;

const valid = (d) => d instanceof Date && !Number.isNaN(d.getTime());
const fmt = (d, opts) => (valid(d) ? new Intl.DateTimeFormat("en-US", { timeZone: TZ, ...opts }).format(d) : "—");

export const fmtDateTime = (iso) => (iso ? fmt(new Date(iso), { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—");
export const fmtTime = (iso) => (iso ? fmt(new Date(iso), { hour: "numeric", minute: "2-digit" }) : "");
export const fmtDate = (d) => fmt(new Date(d), { month: "short", day: "numeric", year: "numeric" });
export const fmtNow = () => fmt(new Date(), { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" });
export const fmtToday = () => fmt(new Date(), { weekday: "short", month: "short", day: "numeric" });

export const fmtZoned = (iso) => (iso ? fmt(new Date(iso), { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" }) : "");

const tzOffsetMs = (t) => {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: TZ, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" })
    .formatToParts(new Date(t)).map((x) => [x.type, x.value]));
  return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second) - t;
};

const PATTERNS = [
  [/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})[ T]+(\d{1,2}):?(\d{2})(?::\d{2})?\s*([AaPp])?\.?[Mm]?\.?$/, (m) => [m[3], m[1], m[2], m[4], m[5], m[6]]],
  [/^(\d{4})-(\d{1,2})-(\d{1,2})[ T]+(\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?\s*([AaPp])?\.?[Mm]?\.?$/, (m) => [m[1], m[2], m[3], m[4], m[5], m[6]]],
];

// Interprets a date/time with no zone as operator-local time and returns ISO 8601 with offset
export const localToIso = (raw) => {
  const s = String(raw ?? "").trim();
  if (!s || /(Z|[+-]\d{2}:?\d{2})$/.test(s)) return null;
  for (const [re, pick] of PATTERNS) {
    const m = s.match(re);
    if (!m) continue;
    let [y, mo, d, h, mi, ap] = pick(m).map((v) => v);
    y = +y < 100 ? 2000 + +y : +y; h = +h;
    if (ap) { const pm = ap.toLowerCase() === "p"; if (h === 12) h = pm ? 12 : 0; else if (pm) h += 12; }
    if (h > 23 || +mi > 59 || +mo < 1 || +mo > 12 || +d < 1 || +d > 31) return null;
    const guess = Date.UTC(y, +mo - 1, +d, h, +mi);
    let t = guess - tzOffsetMs(guess);
    t = guess - tzOffsetMs(t);
    const off = tzOffsetMs(t) / 60000;
    const sign = off >= 0 ? "+" : "-";
    const a = Math.abs(off);
    const pad = (n) => String(n).padStart(2, "0");
    return `${y}-${pad(+mo)}-${pad(+d)}T${pad(h)}:${pad(+mi)}:00${sign}${pad(Math.floor(a / 60))}:${pad(a % 60)}`;
  }
  return null;
};

// YYYY-MM-DD in the operator's time zone
export const dayKey = (d) => (d && valid(new Date(d)) ? new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(d)) : "");
export const todayKey = () => dayKey(new Date());
export const fmtDayKey = (key) => fmt(new Date(`${key}T12:00:00Z`), { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" });
